import React, { Component, Fragment } from 'react';

import { ButtonIcon } from 'components/button';
import { Modal } from 'components/modal';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

import './EngagementModal.scss';

export default class EngagementModal extends Component {
  static propTypes = {
    onClose: PropTypes.func
  };

  options = [
    {
      name: 'access',
      icon: 'keys'
    },
    {
      name: 'progress',
      icon: 'pizza-chart'
    },
    {
      name: 'performance',
      icon: 'checkbox-check'
    },
    {
      name: 'interaction',
      icon: 'chat'
    }
  ];

  renderCards = (option) => (
    <div className="engagement-modal__card">
      <i className={`icon icon-${option.icon}`} />
      <div className="engagement-modal__card__content">
        <h1>
          <I18n label={`general.${option.name}`} />
        </h1>
        <h2>
          <I18n html label={`engagement_modal.${option.name}`} />
        </h2>
      </div>
    </div>
  );

  render() {
    const { onClose } = this.props;

    return (
      <Modal fullSize onClose={onClose} className="engagement-modal-content">
        <Modal.Header>
          {(context) => (
            <Fragment>
              <ButtonIcon
                className="close"
                transparent
                type="secondary"
                icon="close"
                onClick={context.actions.closeModal}
              />
              <h2 className="modal_title">
                <I18n label="general.details" />
              </h2>
            </Fragment>
          )}
        </Modal.Header>
        <Modal.Body>
          <div className="engagement-modal">
            <h1>
              <I18n label="general.engagement" />
            </h1>
            <h2>
              <I18n label="general.what_is" />
            </h2>
            <h3>
              <I18n html label="engagement_modal.content" />
            </h3>
            <div className="engagement-modal__cards">
              {this.options.map(this.renderCards)}
            </div>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}
